// extracted by mini-css-extract-plugin
export default {"sbtH4":"SbtH4_sbtH4__Irzhq"};